import React from 'react';

// Path coordinates are designed on a 16x16 grid (~2.4 to 13.6). Without an
// explicit viewBox the SVG falls back to UA defaults and visually scales
// smaller than the rest of the sidebar icons.
const Chart = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 2.4A1.6 1.6 0 0 0 2.4 4v8A1.6 1.6 0 0 0 4 13.6h8a1.6 1.6 0 0 0 1.6-1.6V4A1.6 1.6 0 0 0 12 2.4H4Zm7.2 3.2a.8.8 0 1 0-1.6 0v4.8a.8.8 0 1 0 1.6 0V5.6ZM8.8 7.2a.8.8 0 1 0-1.6 0v3.2a.8.8 0 1 0 1.6 0V7.2ZM6.4 9.6a.8.8 0 1 0-1.6 0v.8a.8.8 0 1 0 1.6 0v-.8Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default Chart;
